<div *ngIf="hasData"
     class="m-1">

  <h3 class="m-1">
    {{ 'statistics.table.title.' + report.reportType | translate }}
  </h3>

  <table class="table table-striped" [attr.data-test]="report.reportType">

    <tbody>

    <tr>
      <td></td>
      <th scope="col"
          *ngFor="let header of headers"
          class="{{header}}-header">
        {{ header }}
      </th>
    </tr>

    <tr *ngFor="let point of report.points"
        class="{{point.id}}-data">
      <th scope="row" data-test="statistics-label">
        {{ getLabel(point) | async }}
      </th>
      <td *ngFor="let header of headers"
          class="{{point.id}}-{{header}}-data">
        {{ point.values[header] }}
      </td>
    </tr>

    </tbody>

  </table>

</div>
